<div class="h-full flex flex-col">
  <div class="flex flex-col h-full gap-1 justify-between">
    <div
      [ngClass]="{
        'h-[70%]': showVisualOutcome(),
        'h-full': !showVisualOutcome(),
      }"
      class="w-full flex flex-col overflow-hidden relative"
    >
      <flx-code-editor
        [ngModel]="resultString()"
        [options]="codeEditorOptions"
        [warningsFooter]="footerCodeEditorWarnings()"
        [readonly]="true"
        class="h-full min-h-0"
      />
      @if (showResultTypeInfo()) {
        <ng-container
          [ngTemplateOutlet]="outcomeWarning"
          [ngTemplateOutletContext]="{ msg: 'Result will be converted to boolean' }"
        />
      }

      <!-- TODO: rewire to the AI builder harness
      @if (hasError() && showAiActions()) {
        <div class="absolute [top:49px] [left:2px] z-10">
          <button
            #aiActionsButton
            (click)="aiActionsMenu.toggle($event)"
            class="flx-ai-sparkles-cta"
          >
            <flx-icon
              name="stars-flowx-yellow"
              class="w-4 h-4"
            />
          </button>
        </div>
      }
      -->
    </div>

    @if (showVisualOutcome()) {
      <div class="flex flex-col gap-1 h-[30%] w-full items-center justify-center">
        <div
          [innerHTML]="outputArrowSVG"
          class="text-neutral-100 rotate-90 w-3 h-4"
        ></div>
        <div
          class="flex flex-col h-full w-full p-4 rounded items-center justify-center bg-neutral-50 text-neutral-500"
        >
          @if (resultState().phosphorIcon) {
            <i
              [ngClass]="resultState().icon"
              class="text-2xl mb-1 leading-none"
            ></i>
          } @else {
            <flx-icon
              [name]="resultState().icon"
              class="h-6 w-6 mb-1"
            />
          }
          <div class="text-xs">
            {{ resultState().text }}
            <span class="text-sm font-bold uppercase">{{ resultState().state }}</span>
          </div>
        </div>
      </div>
    }
  </div>
</div>

<!-- TODO: rewire to the AI builder harness
<p-menu
  #aiActionsMenu
  [popup]="true"
  [model]="aiActionMenuOptions()"
  styleClass="mt-1 font-semibold flx-prime-menu"
  appendTo="body"
/>
-->

<ng-template
  #outcomeWarning
  let-msg="msg"
>
  <div class="absolute w-full bottom-0 border-neutral-100 p-2">
    <div class="rounded flex gap-1 items-center bg-neutral-100 px-1 py-0.5">
      <flx-icon
        name="info"
        class="h-3 w-3 text-neutral-500"
      ></flx-icon>
      <span class="font-semibold text-xs">{{ msg }}</span>
    </div>
  </div>
</ng-template>
